<template>
  <div class="mobile-container">
    <TopTitle/>
    <div class="main-content">
      <div class="title-text">南阳博望梨韵之旅</div>
      <div>
        <div class="first-line-indentation-title">一、博望黄金梨概述</div>
        <div class="first-line-indentation">
          博望黄金梨是河南省南阳市方城县博望镇的特产，果实金黄、皮薄肉细、含糖量高，被誉为“自然甘甜·金色收获”。每年秋季（9-10月）是黄金梨成熟的季节，也是体验采摘乐趣的最佳时节。
        </div>
        <div class="first-line-indentation-title">二、博望镇本地黄金梨文旅景点</div>
        <div class="first-line-indentation">博望镇已建成以黄金梨为核心的多处观光体验点，形成了完整的文旅格局</div>
        <div class="first-line-indentation">黄金梨园观光区
          拥有2.3万亩连片种植基地，春季可赏梨花，秋季可体验采摘。园区内设有观光道、休闲亭等设施。
        </div>
      </div>
      <div>
        <img class="picture-margin" src="../resource/sightseeingTour1.png"/>
        <div class="picture-caption">图&nbsp;1&nbsp;黄金梨园观光区</div>
        <div class="first-line-indentation">垂钓场与水面休闲区 在梨园周边开发了垂钓水面，供游客休闲。</div>
      </div>
      <div class="picture-proportion">
        <img class="picture-margin-proportion" src="../resource/sightseeingTour2.png"/>
        <img class="picture-margin-proportion" src="../resource/sightseeingTour3.png"/>
      </div>
      <div class="picture-proportion">
        <div class="picture-caption2">图&nbsp;2&nbsp;垂钓场与水面休闲区</div>
        <div class="picture-caption2">图&nbsp;3&nbsp;垂钓场与水面休闲区</div>
      </div>
      <div class="first-line-indentation">
        农家乐与文创体验点，
        园区内开设多家农家乐、小茶馆，提供特色餐饮及梨膏、梨酒等深加工产品的品尝与购买。
      </div>
      <div class="first-line-indentation">黄金梨文化广场 作为每年梨花节、丰收节的主要活动场地，配备灯光和舞台。</div>
      <div class="picture-proportion">
        <img class="picture-margin-proportion" src="../resource/sightseeingTour4.png"/>
        <img class="picture-margin-proportion" src="../resource/sightseeingTour5.png"/>
      </div>
      <div class="picture-proportion">
        <div class="picture-caption2">图&nbsp;4&nbsp;黄金梨文化广场</div>
        <div class="picture-caption2">图&nbsp;5&nbsp;黄金梨文化广场</div>
      </div>
      <div class="first-line-indentation">
        黄金梨深加工展示区 设有梨膏、梨糖等产品的现场演示区，游客可观看加工过程。
      </div>
      <div class="first-line-indentation-title">三、博望镇周边旅游景点（方城县及邻近区域）</div>
      <div class="first-line-indentation">以下景点均在短途车程内，可与黄金梨园共同游览。</div>
      <div class="first-line-indentation">景点名称距离博望镇（约）特色亮点推荐活动：</div>
      <div class="first-line-indentation">丹江大观苑，12
        km。湖光山色、药王殿、思源亭等古建筑群。
      </div>
      <div class="first-line-indentation">漫步湖畔、拍摄倒影、品茶休闲暴瀑峡，18 km。多段飞瀑、屏瀑、畅心谷瀑布观赏、峡谷徒步、亲子探险。
      </div>
      <div class="first-line-indentation"> 七十二潭&天池，22
        km。连续潭池、碧水如镜、倒影如画静态赏景、垂钓、摄影写生。
      </div>
      <div class="first-line-indentation"> 医圣祠(张仲景)，25 km。中医祖庭、文物展览、祈福殿堂文化研学、健康养生体验。
      </div>
      <div class="first-line-indentation"> 武侯祠(诸葛亮)，30
        km。纪念三国名将、古建筑群、文物陈列历史文化参观、红色教育。
      </div>
      <div class="first-line-indentation"> 南阳府衙32
        km，完整保存的府级官署,现为博物馆。
      </div>
      <div class="first-line-indentation"> 古建筑欣赏、历史讲解汉化馆、独山天然盆景、丹江湖库区，35-45
        km。多元自然与人文资源生态观光、研学旅行、湖上游船。
      </div>
      <div class="picture-proportion">
        <img class="picture-margin-proportion3" src="../resource/sightseeingTour6.png"/>
        <img class="picture-margin-proportion3" src="../resource/sightseeingTour7.png"/>
        <img class="picture-margin-proportion3" src="../resource/sightseeingTour8.png"/>
      </div>
      <div class="picture-proportion">
        <div class="picture-caption3">图&nbsp;6&nbsp;丹江大观苑</div>
        <div class="picture-caption3">图&nbsp;7&nbsp;丹江大观苑</div>
        <div class="picture-caption3">图&nbsp;8&nbsp;南阳医圣祠</div>
      </div>
      <div class="first-line-indentation-title">
        四、南阳市重点旅游景点
      </div>

      <div class="first-line-indentation">
        将行程扩展至南阳市区，可体验更丰富的文旅资源
      </div>

      <div class="first-line-indentation">
        景点名称位置特色推荐时长世界月季大观园南阳市区百余种月季、花海景观、夜间灯光秀约2小时白河水上元宇宙南阳市区水上娱乐、灯光秀、亲子项目约1.5小时。
        龙湾温泉南阳市郊碳酸温泉、养生SPA、度假酒店约3小时丹江湖库区(包括宝天曼峡谷漂流)南阳市西北大型水库、漂流、湖光山色半天至一天。
        卧龙岗文化园(汉画馆)南阳市西北汉代壁画、考古展览、互动体验约2小时。
        三馆一院(南阳博物馆等)南阳市中心综合性文博展览、地方史料约2小时独山天然盆景南阳市东南盆景园、自然石景、园林艺术约1小时。
        赊店古镇南阳市东部明清古建筑、古街、手工艺品约2小时方城石川景区方城县生态山谷、徒步路线、观鸟点半天。
      </div>
      <div class="br-line-spacing-padding">
        <!--用于填充图片和文字的空白框-->
      </div>
      <div class="picture-proportion">
        <img class="picture-margin-proportion3" src="../resource/sightseeingTour9.png"/>
        <img class="picture-margin-proportion3" src="../resource/sightseeingTour10.png"/>
        <img class="picture-margin-proportion3" src="../resource/sightseeingTour11.png"/>
      </div>
      <div class="picture-proportion">
        <div class="picture-caption3">图&nbsp;9&nbsp;卧龙岗文化园</div>
        <div class="picture-caption3">图&nbsp;10&nbsp;南阳世界月季大观园</div>
        <div class="picture-caption3">图&nbsp;11&nbsp;南阳龙湾温泉</div>
      </div>
      <div class="first-line-indentation-title">
        五、推荐旅游路线（含博望黄金梨体验）
      </div>
      <div class="first-line-indentation-title">
        1. 金秋采摘·自然文化一日游
      </div>
      <div class="first-line-indentation">上午 抵达博望镇黄金梨园，体验采摘乐趣，品尝新鲜黄金梨，参观深加工展示区。</div>
      <div class="first-line-indentation">中午 在梨园附近的农家乐享用特色午餐。</div>
      <div class="first-line-indentation"> 下午 选择前往丹江大观苑（湖畔漫步）或暴瀑峡（峡谷观瀑）。</div>
      <div class="first-line-indentation">傍晚 若适逢节庆，可在黄金梨文化广场参与活动，或返程。</div>
      <div class="br-line-spacing-padding">
        <!--用于填充图片和文字的空白框-->
      </div>
      <div class="first-line-indentation-title">
        2. 南阳经典·深度体验二日游
      </div>
      <div class="first-line-indentation"> 第一天</div>
      <div class="first-line-indentation"> 上午 游览南阳市区卧龙岗文化园（汉画馆） 或南阳府衙。</div>
      <div class="first-line-indentation"> 下午 参观世界月季大观园。</div>
      <div class="first-line-indentation"> 晚上 体验白河水上元宇宙的灯光秀或龙湾温泉。</div>

      <div class="first-line-indentation"> 第二天</div>
      <div class="first-line-indentation"> 上午 前往博望镇，深度体验黄金梨采摘、品尝梨制品、了解梨文化。</div>
      <div class="first-line-indentation"> 下午 游览医圣祠或武侯祠，感受历史人文。</div>
      <div class="first-line-indentation"> 结束后返程。</div>
      <div class="br-line-spacing-padding">
        <!--用于填充图片和文字的空白框-->
      </div>
      <div class="first-line-indentation-title">六、实用贴士</div>
      <div class="first-line-indentation"> 最佳季节：9-10月（金秋采摘，果实质佳）；3-4月（春季赏花，景色宜人）。</div>
      <div class="first-line-indentation"> 交通方式：景点间自驾或租车最为便利。</div>
      <div class="first-line-indentation"> 住宿选择：博望镇有农家乐和民宿；南阳市区有各类酒店可供选择。</div>
      <div class="first-line-indentation"> 预约咨询：建议通过官方渠道提前了解各景点开放时间和活动安排。</div>
      <div class="br-line-spacing-padding">
        <!--用于填充图片和文字的空白框-->
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted} from 'vue';
// import {useRouter} from 'vue-router';

// eslint-disable-next-line
defineOptions({
  name: 'SightseeingTour'
});

onMounted(() => {
  // user.value = JSON.parse(sessionStorage.getItem("loginUser"));
  // 添加触摸事件支持
});

</script>

<style scoped>
/* 可选：清除默认边距，避免滚动异常 */
body, html {
  margin: 0;
  padding: 0;
}

/* 基础样式 */
.mobile-container {
  height: 93vh;
  width: 100vw;
  position: fixed;
  overflow-y: auto;
  /* 隐藏横向滚动条（防止意外横向滚动） */
  overflow-x: hidden;
  /* 可选：优化滚动体验（iOS端） */
  /*background: linear-gradient(to bottom right, #33872B, #d8ffd0);*/
  background-color: #F2F2E8; /* 白色*/
  /*background-color: #33872B;*//* 绿色*/
  /*background-color: #EAF0E6;*/ /* 黄白色*/
  /* 可选：子元素之间的间距（按需调整） */
  gap: 5px;
  /*  display: flex;
    flex-direction: column;
    align-items: flex-start; !* 垂直顶部对齐 *!
    justify-content: right; !* 水平左对齐 *!*/
  top: 0;
  left: 0;
}

/*整体页面的缩进和填充*/
.main-content {
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
}

/*标题*/
.title-text {
  font-weight: bold; /* 加粗 */
  font-size: 24px;
  text-align: center;
  align-items: flex-start; /* 垂直顶部对齐 */
  justify-content: center; /* 水平左对齐 */
  margin-bottom: 1vh;
}

/*标题行首行缩进*/
.first-line-indentation-title {
  font-size: 18px;
  font-weight: bold; /* 加粗 */
  color: #333333;
  text-indent: 2em;
  text-align: left;
  margin-bottom: 0.5vh;
}

/*首行缩进*/
.first-line-indentation {
  text-indent: 2em;
  text-align: left;
  margin-bottom: 0.5vh;
}

/*图片占比*/
.picture-proportion {
  display: flex; /* 开启Flex布局 */
  gap: 1vw; /* 两个图片之间的间距（可按需调整，如10px） */
  justify-content: center; /* 水平左对齐 */
  height: 30%;
  overflow: hidden;
}

/*图片样式*/
.picture-margin {
  /* 圆角5px */
  flex: 1; /* 两个图片均分容器宽度（各占50%） */
  border-radius: 5px;
  margin-top: 1vh;
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  height: 30%;
}

/*2个图片样式*/
.picture-margin-proportion {
  /* 圆角5px */
  flex: 1; /* 两个图片均分容器宽度（各占50%） */
  border-radius: 5px;
  margin-top: 1vh;
  margin-bottom: 1vh;
  /* 给个基础尺寸，可根据需求调整 */
  width: 47vw;
}


/*3个图片样式*/
.picture-margin-proportion3 {
  /* 圆角5px */
  flex: 1; /* 两个图片均分容器宽度（各占50%） */
  border-radius: 5px;
  margin-top: 1vh;
  margin-bottom: 1vh;
  /* 给个基础尺寸，可根据需求调整 */
  width: 31.333vw;
}


/*图片标题*/
.picture-caption {
  margin-bottom: 1vh;
  font-weight: bold; /* 加粗 */
  color: #333333;
  text-align: center;
}

/*2个图片标题*/
.picture-caption2 {
  margin-bottom: 1vh;
  font-weight: bold; /* 加粗 */
  color: #333333;
  text-align: center;
  /* 给个基础尺寸，可根据需求调整 */
  width: 47vw;
}

/*3个图片标题*/
.picture-caption3 {
  margin-bottom: 1vh;
  font-weight: bold; /* 加粗 */
  color: #333333;
  text-align: center;
  height: 30%;
  /* 给个基础尺寸，可根据需求调整 */
  width: 31.333vw;
}

/*行间距*/
.br-line-spacing-padding {
  height: 1vh;
}

</style>